// src/components/MatchingGame/MatchingGame.jsx

import React, { useState, useEffect } from 'react';
import './MatchingGame.css';

const MatchingGame = ({
                          leftItems = [],
                          rightItems = [],
                          wrongAnswerRecords = [],
                          onPairSelect = () => {},
                          onAllMatched = () => {},
                          onWrongItemClick = () => {}
                      }) => {

    // 状态初始化
    const [leftState, setLeftState] = useState(
        leftItems.map((item, idx) => ({
            id: idx,
            text: item.content,
            matched: false,
            wrong: false
        }))
    );

    const [rightState, setRightState] = useState(
        rightItems.map((item, idx) => ({
            id: idx,
            text: item.content,
            matched: false,
            wrong: false
        }))
    );

    // 当前选中的侧（'left' / 'right' / null）和索引
    const [selectedSide, setSelectedSide] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);

    // 标记是否所有选项已匹配
    const [alreadyAllMatched, setAlreadyAllMatched] = useState(false);

    // 根据 wrongAnswerRecords 标记错误项
    useEffect(() => {
        console.log("wrongAnswerRecords " + wrongAnswerRecords);
        if (wrongAnswerRecords.length > 0) {
            const newLeftState = leftState.map((item) => {
                const isWrong = wrongAnswerRecords.some(record => record.blankOrder === item.id + 1);
                return { ...item, wrong: isWrong};
            });
            setLeftState(newLeftState);
        }
    }, [wrongAnswerRecords]);

    const handleItemClick = (side, index) => {
        const item = side === 'left' ? leftState[index] : rightState[index];
        console.log("item.wrongRecord " + item.wrongRecord);
        if (item.wrong && wrongAnswerRecords && wrongAnswerRecords.length > 0) {
            onWrongItemClick(item.id + 1);
            return;
        }

        // 如果已匹配，则不再响应点击
        if (side === 'left' && leftState[index].matched) return;
        if (side === 'right' && rightState[index].matched) return;

        // 如果当前没有选中，则选中它
        if (selectedSide === null) {
            setSelectedSide(side);
            setSelectedIndex(index);
            return;
        }

        // 如果点击在同一侧
        if (selectedSide === side) {
            // 如果点到同一个索引 => 取消选中
            if (selectedIndex === index) {
                setSelectedSide(null);
                setSelectedIndex(null);
            } else {
                // 若点到同侧的其他项 => 切换选中
                setSelectedIndex(index);
            }
            return;
        }

        // 如果点击在另一侧 => 发起匹配
        if (selectedSide !== side) {
            // 左右索引对应
            let leftIndex, rightIndex;
            if (side === 'left') {
                leftIndex = index;
                rightIndex = selectedIndex;
            } else {
                leftIndex = selectedIndex;
                rightIndex = index;
            }

            // 调用回调
            onPairSelect(leftIndex, rightIndex, (serverResult) => {
                if (serverResult.correct) {
                    // 匹配成功
                    setLeftState((prev) =>
                        prev.map((item, i) =>
                            i === leftIndex ? { ...item, matched: true } : item
                        )
                    );
                    setRightState((prev) =>
                        prev.map((item, i) =>
                            i === rightIndex ? { ...item, matched: true } : item
                        )
                    );
                } else {
                    // 匹配失败 => 标红
                    setLeftState((prev) =>
                        prev.map((item, i) =>
                            i === leftIndex ? { ...item, wrong: true } : item
                        )
                    );
                    setRightState((prev) =>
                        prev.map((item, i) =>
                            i === rightIndex ? { ...item, wrong: true } : item
                        )
                    );

                    // 1秒后取消红色
                    setTimeout(() => {
                        setLeftState((prev) =>
                            prev.map((item) => ({ ...item, wrong: false }))
                        );
                        setRightState((prev) =>
                            prev.map((item) => ({ ...item, wrong: false }))
                        );
                    }, 1000);
                }

                // 无论对错，取消选中
                setSelectedSide(null);
                setSelectedIndex(null);
            });
        }
    };

    // 检测是否所有都 matched
    useEffect(() => {
        if (alreadyAllMatched) return;

        const allMatchedLeft = leftState.every(item => item.matched);
        const allMatchedRight = rightState.every(item => item.matched);

        if (allMatchedLeft && allMatchedRight && leftState.length > 0) {
            setAlreadyAllMatched(true);
            onAllMatched();
        }
    }, [leftState, rightState, alreadyAllMatched, onAllMatched]);

    // 将左、右按相同下标“一一对应”展示
    // 注意：仅当leftState.length === rightState.length时最简单
    // 如果两侧数量不一致，需要做保护或其他业务处理
    return (
        <div className="match-container">
            {leftState.map((leftItem, i) => {
                const rightItem = rightState[i];

                // 若右侧数量不够，会报错。你可判断 if (!rightItem) return null;

                // 判断高亮
                const isLeftSelected = (selectedSide === 'left' && selectedIndex === i);
                const isRightSelected = (selectedSide === 'right' && selectedIndex === i);

                return (
                    <div className="match-row" key={`row-${i}`}>
                        {/* 左边选项 */}
                        <div
                            key={leftItem.id}
                            className={[
                                'match-item',
                                leftItem.matched ? 'matched' : '',
                                leftItem.wrong ? 'wrong' : '',
                                isLeftSelected ? 'highlight' : ''
                            ].join(' ')}
                            onClick={() => handleItemClick('left', i)}
                        >
                            {leftItem.text}
                        </div>

                        {/* 右边选项 */}
                        {rightItem && (
                            <div
                                key={rightItem.id}
                                className={[
                                    'match-item',
                                    rightItem.matched ? 'matched' : '',
                                    rightItem.wrong ? 'wrong' : '',
                                    isRightSelected ? 'highlight' : ''
                                ].join(' ')}
                                onClick={() => handleItemClick('right', i)}
                            >
                                {rightItem.text}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default MatchingGame;